/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
    REQUEST_DEVICES,
    REQUEST_DEVICE_PROFILES, REQUEST_PROFILE_BY_PROFILEID
} from './actionTypes'
import {
    call,
    put,
    takeEvery,
} from 'redux-saga/effects'
import { Devices as deviceApi } from './devices'
import {
    fetchDevicesSuccess, fetchDevicesFailure,
    fetchDeviceProfilesFailure, fetchDeviceProfilesSuccess,
    fetchProfileByProfileIdSuccess, fetchPofileByProfileIdFailure

} from './actions'


function* fetchDevicesForSaga(action) {
    try {
        const response = yield call(deviceApi.getDevices, action.options, action.groupId)
        yield put(fetchDevicesSuccess(response.data))
    } catch (error) {
        yield put(fetchDevicesFailure(error));
    }
}

export function* devicesRequestSaga() {
    yield takeEvery(REQUEST_DEVICES, fetchDevicesForSaga);
}

function* fetchDeviceProfilesForSaga(action) {
    try {
        const response = yield call(deviceApi.getDeviceProfiles, action.options, action.groupId)
        yield put(fetchDeviceProfilesSuccess(response.data))
    } catch (error) {
        yield put(fetchDeviceProfilesFailure(error));
    }
}

export function* deviceProfilesRequestSaga() {
    yield takeEvery(REQUEST_DEVICE_PROFILES, fetchDeviceProfilesForSaga);
}


function* fetchDeviceProfilesByProfileId(action) {
    try {
        const response = yield call(deviceApi.getDeviceProfileByProfileId, action.profileId)
        yield put(fetchProfileByProfileIdSuccess(response.data))
    } catch (error) {
        yield put(fetchPofileByProfileIdFailure(error));
    }
}

export function* deviceProfilesByProfileIdRequestSaga() {
    yield takeEvery(REQUEST_PROFILE_BY_PROFILEID, fetchDeviceProfilesByProfileId);
}

